import React from 'react';
import { useRouter } from 'next/router';
import FiltersContextProvider from '@/finsight/application/FiltersContext';
import InventoryTableContextProvider from '@/finsight/application/Bonds/InventoryTableContext';
import BwicTableContextProvider from '@/finsight/application/Bonds/BwicTableContext';
import TileContextProvider from '@/finsight/application/Bonds/TileContext';
import BondsAssetClassesContextProvider from '@/finsight/application/Bonds/BondsAssetClassesContext';
import { IQueryParams } from '@/finsight/domain/vo/IQueryParams';
import { useDictionariesContext } from '@/finsight/application/Dictionaries/DictionariesContext';
import { defaultTileFilterPayload } from './constants';

export const ComposeBondsTileContext = (props) => {
  const { sectorsList } = useDictionariesContext();
  const { query: { sector } }:{ query: IQueryParams } = useRouter();
  const sectorItem = sectorsList[sector];
  const {
    bondTileData: {
      currentUserDataByFilter,
      enabled,
      filterPayload,
   },
  } = props;
  const { ...baseParams } = defaultTileFilterPayload;
  const bwicData = { bwics: currentUserDataByFilter.bwic };
  const inventoriesData = { inventories: currentUserDataByFilter.inventory };

  return (
    <BondsAssetClassesContextProvider>
      <TileContextProvider
        enabled={ enabled }
        filterPayload={ filterPayload }
        sectorItem={ sectorItem }
      >
        <FiltersContextProvider initial={ { baseParams } } sectorItem={ sectorItem }>
          <InventoryTableContextProvider
            isTile
            initial={ inventoriesData }
          >
            <BwicTableContextProvider
              isTile
              initial={ bwicData }
            >
              { props.children }
            </BwicTableContextProvider>
          </InventoryTableContextProvider>
        </FiltersContextProvider>
      </TileContextProvider>
    </BondsAssetClassesContextProvider>
  );
};
